import {authRequest} from "@/shared/api";
import {AuthPayload, AuthResponse} from "../model";

export const login = async (payload: AuthPayload): Promise<AuthResponse> => {
  return authRequest("/api/users/login", payload);
};

export const register = async (payload: AuthPayload): Promise<AuthResponse> => {
  return authRequest("/api/users/register", payload);
};

export const forgot = async (payload: AuthPayload): Promise<AuthResponse> => {
  return authRequest("/api/users/change-password", payload);
};

export const verify = async (phone: string, code: number): Promise<AuthResponse> => {
  return authRequest("/api/users/verify", {phone, code});
};



